class AccordionItems {
  constructor(el) {
    this.el = el;
    // Ahora seleccionas directamente los botones y paneles dentro del acordeón.
    this.elItems = this.el.querySelectorAll(".accordion__button"); 

    for (let button of this.elItems) {
      new AccordionItem(button, this.el.dataset.type); // Pasas cada botón directamente.
    }
  }
}

class AccordionItem {
  constructor(button, type) {
    this.elButton = button;
    this.type = type;
    // El panel ahora será el siguiente hermano del botón, ya que no hay contenedor.
    this.elPanel = this.elButton.querySelector(".accordion__panel");
    this.elButtonIcon = this.elButton.querySelector(".accordion__button-icon");
    this.elButtonIconSvg = this.elButton.querySelector(".accordion__button-icon .delete");

    this.handleResize = this.onResize.bind(this);

    this.elButton.addEventListener("click", this.toggleAccordion.bind(this), false);
    
    window.addEventListener("resize", this.handleResize);
  }

  toggleAccordion(ev) {
    let accordionExpanded = this.elButton.getAttribute("aria-expanded") === "true";
    if (!accordionExpanded) {
      this.openAccordion();
    } else {
      this.closeAccordion();
    }
  }

  openAccordion() {
    this.elPanel.style.transition = "height .25s ease-in-out, opacity .5s linear";
    this.elPanel.style.height = this.elPanel.scrollHeight + "px";
    this.elPanel.style.opacity = "1";
    this.elPanel.classList.add("expanded");
    this.elButton.setAttribute("aria-expanded", true);
    this.elButtonIconSvg.style.display = "none";
    this.elButtonIcon.style.animation = "";
  }

  closeAccordion() {
    this.elPanel.style.transition = "height .25s linear, opacity .1s linear";
    this.elPanel.style.opacity = "0";
    this.elPanel.style.height = "0";
    this.elButton.setAttribute("aria-expanded", false);
    this.elPanel.classList.remove("expanded");
    this.elButtonIcon.style.animation = "";
    this.elButtonIconSvg.style.display = "block";
  }

  onResize() {
    if (this.elButton.getAttribute("aria-expanded") === "true") {
      this.elPanel.style.height = this.elPanel.scrollHeight + "px";
    }
  }
}

const initAccordions = () => {
  const accordions = document.querySelectorAll(".js-accordion");

  if (accordions) {
    for (let accordion of accordions) {
      new AccordionItems(accordion);
    }
  }
};

initAccordions();